import React from "react";
import clsx from "clsx";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Trad } from "src/components/";
import { _NumberField } from "../form";
import { TNumberFieldProps } from "../form/NumberField";

type State = "GOOD" | "LOW" | "ACCEPTABLE" | "NEUTRAL";

type TStateFieldProps = TNumberFieldProps & {
    AcceptableLimit: number;
    GoodLimit: number;
    LowLimit: number;
    NeutralVal?: number;
    ReverseDirection?: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => ({
    low: {
        color: palette.error.main
    },
    acceptable: {
        color: palette.warning.main
    },
    good: {
        color: palette.success.main
    },
    neutral: {
        color: palette.info.main
    }
}));

export const _StateField: React.FC<TStateFieldProps> = ({ AcceptableLimit, GoodLimit, LowLimit, ReverseDirection, Value, NeutralVal, ...rest }) => {
    const classes = useStyles();

    const getState = (): State => {
        let state: State = "LOW";

        if (ReverseDirection) {
            if (Value >= GoodLimit) {
                state = "GOOD";
            } else if (Value < GoodLimit && Value >= AcceptableLimit) {
                state = "ACCEPTABLE";
            }
        } else {
            if (Value <= GoodLimit) {
                state = "GOOD";
            } else if (Value > GoodLimit && Value <= AcceptableLimit) {
                state = "ACCEPTABLE";
            }
        }

        if (NeutralVal != undefined && NeutralVal == Value) {
            state = "NEUTRAL";
        }

        return state;
    };

    const getStateMesage = (state: State): string => {
        switch (state) {
            case "ACCEPTABLE":
                return "ACCETTABILE";
            case "GOOD":
                return "BUONA";
            case "NEUTRAL":
                return "ND";
        }
        return "SCARSA";
    };

    const state = getState();
    const stateMessage = getStateMesage(state);

    return (
        <_NumberField
            Value={Value}
            Adornment={null}
            {...rest}
            helperText={Trad.Trad(stateMessage)}
            size="small"
            FormHelperTextProps={{
                disabled: false,
                className: clsx({
                    [classes.low]: state == "LOW",
                    [classes.acceptable]: state == "ACCEPTABLE",
                    [classes.good]: state == "GOOD",
                    [classes.neutral]: state == "NEUTRAL"
                })
            }}
            Disabled
        />
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/StateField.tsx